import { observer } from 'mobx-react-lite'
import { Icon } from 'shared/ui'
import { TextField } from 'shared/ui/TextField'
import { useChatbotAnalyticContext } from 'pages/chatbot/pages/chatbotAnalytic/context/chatbotAnalyticContext'
import styles from './styles.module.scss'

export const ChatbotAnalyticSearch = observer(() => {
  const { list } = useChatbotAnalyticContext()
  const { setSearch, search } = list

  return (
    <div className={styles.searchWrap}>
      <div className={styles.search}>
        <Icon icon='search' fontSize={20} padding={6} color='var(--content-primary-tertiary)' />
        <TextField
          variant='integrated'
          InputProps={{
            placeholder: 'Search...',
          }}
          onChange={setSearch}
          value={search || ''}
          ariaLabel='StatisticSearch'
        />
      </div>
    </div>
  )
})
